/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

export default {
  articles: [
    {
      id: 1,
      title: "Omezení provozu skleníku 12. a 13. října",
      slug: "omezeni-provozu-skleníku-12-a-13-rijna",
      author: "BZUK",
      tags: ["notification"],
      publishedAt: new Date(Date.parse("2019-11-05 12:33:01")),
      excerpt:
        "V sobotu 12. října bude skleník z technických důvodů uzavřen, v neděli 13. října bude otevřen od 12:00. Omlouváme se návštěvníkům za komplikace.",
      content:
        "V sobotu 12. října bude skleník z technických důvodů uzavřen, v neděli 13. října bude otevřen od 12:00. Omlouváme se návštěvníkům za komplikace."
    },
    {
      id: 2,
      title: "Poradna pro veřejnost se 15. října nekoná",
      slug: "poradna-pro-verejnost-se-15-rijna-nekona",
      author: "BZUK",
      tags: ["notification"],
      publishedAt: new Date(Date.parse("2019-11-04 11:12:01")),
      excerpt:
        "V úterý 15. října se nebude konat pravidelná poradna pro veřejnost z důvodu stěhování subtropické sbírky. Děkujeme za pochopení a omlouváme se případným zájemcům.",
      content:
        "V úterý 15. října se nebude konat pravidelná poradna pro veřejnost z důvodu stěhování subtropické sbírky. Děkujeme za pochopení a omlouváme se případným zájemcům."
    },
    {
      id: 3,
      position: 0,
      image: "/img/featured1.jpg",
      title: "21. umisťovací výstava koček bez domova",
      subtitle: "Datum: 16.11.2019 - 10:00 - 17:00",
      slug: "21-umistovaci-vystava-kocek-bez-domova",
      author: "BZUK",
      tags: ["featured", "event"],
      publishedAt: new Date(Date.parse("2019-11-04 11:12:01")),
      excerpt:
        "Budete si zde moci vybrat ze spousty koťátek a kočiček s veterinárním osvědčením nebo jim alespoň přispět finančním či materiálním darem.",
      content: `<p>Výstava se koná 16. listopadu 2019 od 10:00 do 17:00 v horním skleníku Botanické zahrady PřF UK.</p>
<br/>
<p>Budete si zde moci vybrat ze spousty koťátek a kočiček s veterinárním osvědčením,
nebo jim alespoň přispět finančním či materiálním darem.</p>

<p>Spolupořádá:<br/>
<b>Sdružení na ochranu zvířat v krajní nouzi</b><br/>
Na pláni 31, Praha 5<br/>
tel.: 603 225 948<br/>
email: <a href="mailto:sdruzeni@kocici-utulek.cz">sdruzeni@kocici-utulek.cz</a>
      </p>`
    },
    {
      id: 4,
      position: 1,
      image: "/img/featured2.jpg",
      title: "Výtvarné kurzy pro veřejnost a pro studenty PřF UK",
      subtitle: "Datum: 12.10.2019 - 10:00 - 18.04.2020 - 10:00",
      slug: "vytvarne-kurzy-pro-verejnost-a-pro-studenty-prf-uk",
      author: "BZUK",
      tags: ["featured", "event"],
      publishedAt: new Date(Date.parse("2019-11-04 11:12:01")),
      excerpt:
        "Zveme vás na další pololetí kurzů Kreslení a malování rostlin s akad. mal. Lucií Crocro v Botanické zahradě PřF UK.",
      content: `<p>Zveme vás na další pololetí kurzů Kreslení a malování rostlin s akad. mal. Lucií Crocro v Botanické zahradě PřF UK.</p>

<p>Kurzy jsou vhodné pro pokročilé i pro úplné začátečníky. Můžete si na nich vyzkoušet kresbu tužkou, akvarelovými pastelkami, pastelem, či olejomalbu.</p>
<br/>
<p>Cena za jeden tříhodinový kurz:</p>
<br/>
<p>
<table>
<tr><td>Studenti PřF UK</td><td>– zdarma</td></tr>
<tr><td>dospělí</td><td>– 390 Kč</td></tr>
<tr><td>děti</td><td>– 90 Kč</td></tr>
<tr><td>příplatek za olejomalbu</td><td>– 90 Kč</td></tr>
</table>
</p>
<br/>
<p>
<table>
<th>
<tr><td>Téma</td><td>Veřejnost</td><td>Studenti PřF UK</td></tr>
<tr><td>Světlo a stíny rostlin</td><td>Veřejnost</td><td>Studenti PřF UK</td></tr>
<tr><td>Architektura rostlin</td><td>Veřejnost</td><td>Studenti PřF UK</td></tr>
<tr><td>Rostliny ve vzájemné kompozici</td><td>Veřejnost</td><td>Studenti PřF UK</td></tr>
<tr><td>Linie a struktury rostlin</td><td>Veřejnost</td><td>Studenti PřF UK</td></tr>
<tr><td>Vnitřní a vnější prostor rostlin</td><td>Veřejnost</td><td>Studenti PřF UK</td></tr>
<tr><td>Objemy a geometrie rostlin</td><td>Veřejnost</td><td>Studenti PřF UK</td></tr>
<tr><td></td><td>vždy v sobotu 10:00 až 13:00</td><td>vždy ve čtvrtek 10:00 až 13:00</td></tr>
<tr><td></td><td>Rezervace:</td><td>Rezervace:</td></tr>
<tr><td></td><td>773 247 227</td><td>736 503 730</td></tr>
<tr><td></td><td>luciecrocro@seznam.cz</td><td>anna.prochazkova@natur.cuni.cz</td></tr>
</th>
</table>
</p>
`
    },
    {
      id: 5,
      position: 2,
      title: "Orchideje 2019",
      subtitle: "Datum: 25.10.2019 - 10:00 - 10.11.2019 - 17:00",
      slug: "orchideje-2019",
      author: "BZUK",
      image: "/img/featured3.jpg",
      tags: ["featured", "event"],
      publishedAt: new Date(Date.parse("2019-11-04 11:12:01")),
      excerpt:
        "Zveme vás na výstavu orchidejí. Kromě výstavní části vás i letos čeká také prodej a poradenská služba.",
      content: `<p>Zveme vás na výstavu orchidejí. Kromě výstavní části vás i letos čeká také prodej a poradenská služba.</p>
<p>Výstava bude otevřená každý den od 10:00 do 17:00, vstoupit bude ale možné nejpozději v 16:30.</p>
<br/>
<p>
Vstupné:<br/>
plné: 100 Kč<br/>
snížené: 50 Kč<br/>
</p>
`
    },
    {
      id: 6,
      title: "Navštivte nás",
      slug: "visit-us",
      author: "BZUK",
      tags: [],
      publishedAt: new Date(Date.parse("2019-10-04 11:12:01")),
      excerpt: "",
      content: `
<div style="display: flex; align-items: center; flex-direction: column; text-align: center; width: 100%;">
    <div style="flex-grow: 0; font-size: 3rem;">Vstupné</div>
    <div style="display: flex; flex-direction: column; width: 100%; margin: 1.75rem 0 0 0; padding: 0 1rem 0 1rem;">
        <div class="columns" style="background-color: #eaeaea;">
            <div class="column is-4"></div>
            <div class="column is-4">Skleníky</div>
            <div class="column is-4">Exteriéry</div>
        </div>
        <div class="columns">
            <div class="column is-4" style="text-align: left;">Dospělí</div>
            <div class="column is-4">55 Kč</div>
            <div class="column is-4">zdarma</div>
        </div>
        <div class="columns" style="background-color: #eaeaea;">
            <div class="column is-4" style="text-align: left;">Děti, studenti (do 26 let), senioři</div>
            <div class="column is-4">30 Kč</div>
            <div class="column is-4">zdarma</div>
        </div>
        <div class="columns">
            <div class="column is-4" style="text-align: left;">Rodinné vstupné (2 dospělí, maximálně 3 děti 6-15 let)</div>
            <div class="column is-4">130 Kč</div>
            <div class="column is-4">zdarma</div>
        </div>
        <div class="columns" style="background-color: #eaeaea;">
            <div class="column is-4" style="text-align: left;">ZTP, děti do 5 let, pedagogický doprovod, studenti a zaměstnanci PřF UK</div>
            <div class="column is-4">zdarma</div>
            <div class="column is-4">zdarma</div>
        </div>
    </div>
</div> 
      `
    }
  ]
};
